import { Controller } from "@hotwired/stimulus"
import { useActionCable } from "shared/web_socket"

export default class extends Controller {
  connect() {
    this.actionCable = useActionCable(this, {
      channel: "Admin::AiTaskChannel"
    })
  }

  disconnect() {
    if (this.actionCable) {
      this.actionCable.unsubscribe()
    }
  }

  onCableReceived(message) {
    // Generic handler for all ai_task_* events
    if (!message.event?.startsWith("ai_task_")) return

    // Forward all server payload fields and add camelCase aliases for backward compatibility
    const payload = {
      ...message,
      taskType: message.task_type,
      taskId: message.task_id
    }

    // Enqueue the event to prevent race conditions
    if (global.state?.aiTaskEvents) {
      global.state.aiTaskEvents.push(payload)
    }

    // Convert event name into DOM event namespace (ai_task_completed -> ai-task:completed)
    const eventName = message.event.replace("ai_task_", "ai-task:")

    // Dispatch the event immediately
    const event = new CustomEvent(eventName, {
      detail: payload,
      bubbles: false
    })
    window.dispatchEvent(event)
  }
}
